import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type AudioPlayer from './audio-player.vue'

export const preloadLoad = ['auto', 'metadata', 'none']
export const audioFormat = [
  'MP3',
  'OGG',
  'AAC',
  'WAV',
  'WMA',
  'WEBM',
  'FLAC',
  'ALAC',
  'AMR',
  'MIDI',
]

export const audioPlayerProps = buildProps({
  src: {
    type: String,
    required: true,
  },
  // 显示音屏面板
  controls: {
    type: Boolean,
    default: true,
  },
  // 自动播放
  autoplay: {
    type: Boolean,
    default: false,
  },
  // 静音播放
  muted: {
    type: Boolean,
    default: false,
  },
  // 循环
  loop: {
    type: Boolean,
    default: false,
  },
  // 预加载
  preload: {
    type: String,
    default: 'auto',
    values: preloadLoad,
  },
  // 音频类型
  format: {
    type: String,
    default: 'MP3',
    values: audioFormat,
  },
} as const)

// props
export type AudioPlayerProps = ExtractPropTypes<typeof audioPlayerProps>

// instance
export type AudioPlayerInstance = InstanceType<typeof AudioPlayer>
